module.exports = __webpack_public_path__ + "static/media/secondamano.0ff033e7.png";